import exDexApi from "./exdexapi";
import api from "./api";

export const getWatchList = () => {
  return api.get("/bookmarkproject");
};

export const getAiSignalWatchList = (filterString: string) => {
  return api.get(`/card-bookmarks${filterString}`);
};
